import React, { useState } from 'react';
import { Lock, Eye, EyeOff, AlertCircle } from 'lucide-react';

const StayInformed = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (password === 'test') {
      // Redirect to Google Drive folder
      window.location.href = 'https://drive.google.com/drive/folders/1KQn5GUF_ceHVTaNvO56T3Qey8D_Dp91y';
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-[#123f1e] flex items-center justify-center px-4 pt-32 pb-20">
      <div className="max-w-md w-full">
        {/* Lock Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-[#febc04]/20 rounded-full border-2 border-[#febc04]/30 mb-6 backdrop-blur-sm">
            <Lock className="w-10 h-10 text-[#febc04]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4 tracking-tight">
            Stay Informed
          </h1>
          <p className="text-lg text-white/80 font-light leading-relaxed">
            Access important updates and resources for our GoLD families
          </p>
        </div>

        {/* Password Form */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-[#123f1e] mb-3">
                Enter Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  aria-invalid={!!error}
                  aria-describedby={error ? 'password-error' : undefined}
                  className="w-full px-4 py-4 pr-12 border-2 border-gray-200 rounded-xl focus:border-[#febc04] focus:outline-none focus:ring-2 focus:ring-[#febc04]/20 transition-all duration-200 text-lg"
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#123f1e] transition-colors duration-200 focus:outline-none"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {/* Error Message */}
            {error && (
              <div id="password-error" role="alert" className="flex items-center gap-3 p-4 bg-red-50 border border-red-200 rounded-xl">
                <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0" />
                <p className="text-sm text-red-700 font-medium">{error}</p>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full py-4 bg-[#123f1e] text-white font-semibold rounded-xl hover:bg-[#1a5a2d] transition-all duration-200 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#123f1e] focus:ring-offset-2 text-lg"
            >
              Access Resources
            </button>
          </form>

          {/* Help Text */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              Need access? Contact the school office at{' '}
              <a href="tel:718-583-8975" className="font-semibold text-[#123f1e] hover:text-[#7d5800] transition-colors">
                (718) 583-8975
              </a>
            </p>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-sm text-white/70 font-light">
            This area contains confidential family resources and school updates
          </p>
        </div>
      </div>
    </div>
  );
};

export default StayInformed;
